var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-layout',{staticClass:"layout"},[_c('Header'),_c('a-layout',[_c('Sidebar'),_c('a-layout',[_c('Nav'),_c('Content')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }